import type { StaffRole } from "./types";

const STAFF_APP_HOSTNAMES = new Set([
  "staff.assemblestudio.uk",
  "staging-staff.assemblestudio.uk",
]);

export type StaffHostRoute =
  | { kind: "staff-home"; canonicalPath: "/" | "/admin" }
  | { kind: "instructor-home" }
  | { kind: "instructor-session"; sessionId: string };

export function isStaffAppHostname(hostname: string) {
  return STAFF_APP_HOSTNAMES.has(hostname.trim().toLowerCase().replace(/\.$/, ""));
}

export function resolveStaffHostRoute(path: string, hostname: string): StaffHostRoute | null {
  if (!isStaffAppHostname(hostname)) return null;
  if (path === "/instructor") return { kind: "instructor-home" };
  const sessionPrefix = "/instructor/session/";
  if (path.startsWith(sessionPrefix)) {
    return { kind: "instructor-session", sessionId: decodeURIComponent(path.slice(sessionPrefix.length)) };
  }
  if (path === "/admin") return { kind: "staff-home", canonicalPath: "/admin" };
  return { kind: "staff-home", canonicalPath: "/" };
}

export function staffWorkspaceForRole(role: StaffRole) {
  return role === "instructor" ? "instructor" : "admin";
}
